// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCZmx_mSqf8TMt2KbeMBNm-9CE74xdJs7k",
    authDomain: "cryto-nary.firebaseapp.com",
    projectId: "cryto-nary",
    storageBucket: "cryto-nary.appspot.com",
    messagingSenderId: "815671101204",
    appId: "1:815671101204:web:845e467b2858c9e8ebe401"
  };

  export default firebaseConfig;